export default function processStr(str: string) {
  if (!str) return "";

  return str
    .replace(/[.,/#!$%^&*;:{}=\-_'`~()™]/g, "")
    .replace(/\s{2,}/g, " ")
    .replace(/\s/g, "-");
}
